import styled from "styled-components";

export const PromotionPackageStyled = styled.div`
  padding: 7.4px 50px 27.9px 50px;
  background: ${({ theme }) => theme.COLORS.GRAY_6};
  .promo_title {
    margin-bottom: 19px;
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S12};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
  }
  .promo_sub_title {
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S12};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
  }
  .row_promo {
    display: flex;
    justify-content: space-between;
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S12};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
  }

  .theme_standard {
  }
`;
